/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, April 18th 2022, 10:29:42 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import { WYSIWYGInput, WYSIWYGInputProps } from "ui-widgets/forms";
import { ContextTagSelectorButtonWrapper } from "common/components/context-tags";
import { useServiceBuilderContext } from "service-builder/providers";
import { OSActionButton } from "ui-widgets";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

type HTMLContentInputProps<T> = Pick<WYSIWYGInputProps<T>, "schema_field_key" | "label" | "helperText" | "minHeight">;

export const HTMLContentInput = <T,>(props: HTMLContentInputProps<T>) => {
  const [editorContentToAppend, setEditorContentToAppend] = React.useState<string>(null);

  const {
    processDefinitionContext: { currentProcessDefinition },
  } = useServiceBuilderContext();

  return (
    <>
      <Stack direction="row" justifyContent="space-between">
        <Typography variant="h4" sx={{ fontWeight: 800, fontSize: "0.8rem" }}>
          {props.label}
        </Typography>
        <ContextTagSelectorButtonWrapper
          onCopyContextTag={({ tag, tagName }) => {
            setEditorContentToAppend(`${tagName}: ${tag}`);
          }}
          copiedMessage="Appended to Layout!!"
          contextTagsAPIFilters={{ process_definition: currentProcessDefinition.id }}
        >
          {({ openContextTagsFn }) => (
            <OSActionButton onClick={openContextTagsFn} variant="contained">
              Use Context Tags
            </OSActionButton>
          )}
        </ContextTagSelectorButtonWrapper>
      </Stack>
      <WYSIWYGInput<T>
        schema_field_key={props.schema_field_key}
        label={null}
        minHeight={props.minHeight}
        appendContents={editorContentToAppend}
      />
    </>
  );
};
